import BookingTemplate from "../../../templates/users/booking";

const BookingScreen = () => {
  return <BookingTemplate />;
};

export default BookingScreen;
